// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-add-bank[data-v-1f2cbb33] {\n  position: absolute;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
